import DownloadButton from './DownloadButton';
import { variantTypes } from '@/Framework/UI/Atoms/Button/ActionButton/constants';

export default DownloadButton;
export { DownloadButton, variantTypes };
